import React from 'react';
import styled from 'styled-components';
import { Input as BaseInput, Icon } from 'semantic-ui-react';

const Input = styled(BaseInput)`
    &.disabled {
        &,
        input:disabled,
        .disabled {
            opacity: 1 !important;
            background-color: #fffaf3;
        }
    }
`;

export default function EmailField({ userLookupStatus, onUserLookup, resetUserLookup, meta, disabled, ...props }) {
    return (
        <Input
            {...props}
            disabled={disabled}
            className={disabled ? 'disabled' : ''}
            icon={
                userLookupStatus === 'EXISTS' && (
                    <Icon name="checkmark" color="green" inverted={true} circular={true} />
                )
            }
            loading={userLookupStatus === 'CHECKING'}
        />
    );
}
